import { getDevice } from '@webtv/devices';
import { Feature, isFeatureEnabled } from '@webtv/feature-toggles';
var unsupportedDevices = ['Puck', 'Glass'];

var useOauthEnabled = function useOauthEnabled() {
  var device = getDevice();
  return isFeatureEnabled(Feature.Oauth) && !unsupportedDevices.includes(device.friendlyName);
};

export default useOauthEnabled;